import { apiGetAccount } from '../../common/api/profile'
import {
  apiCreateAssessmentFile,
  apiDeleteAssessmentFile,
  apiInviteToAssessmentFileBulk
} from '../../common/api/assessment'

const fetchAssessmentFiles = pupilId => ({
  requestPrefix: 'ASSESSMENT_STORE:FETCH',
  params: { pupilId },
  request: () =>
    apiGetAccount(pupilId, {
      include:
        'account.student_type.assessment_files,account.student_type.assessment_file.details,account.student_type.assessment_file.timestamps,account.student_type.assessment_file.contributors,account.student_type.assessment_file.contributions,account.student_type.assessment_file.student_type.account.names,account.student_type.assessment_file.works'
    })
})

const createAssessmentFile = (title, context, studentId, works) => ({
  requestPrefix: 'ASSESSMENT_STORE:CREATE',
  request: () => apiCreateAssessmentFile(title, context, studentId, works)
})

const deleteAssessmentFile = id => ({
  requestPrefix: 'ASSESSMENT_STORE:DELETE',
  params: { id },
  request: () => apiDeleteAssessmentFile(id)
})

const openInvitationAssessmentDialog = id => ({
  type: 'ASSESSMENT_STORE:INVITATION_ASSESSMENT_DIALOG:OPEN',
  params: {
    id
  }
})

const closeInvitationAssessmentDialog = () => ({
  type: 'ASSESSMENT_STORE:INVITATION_ASSESSMENT_DIALOG:CLOSE'
})

const inviteToAssessmentFile = (assessmentFileId, emails, recaptchaToken) => ({
  requestPrefix: 'ASSESSMENT_STORE:INVITE',
  params: { assessmentFileId, emails },
  request: () =>
    apiInviteToAssessmentFileBulk({
      assessment_file_id: assessmentFileId,
      emails,
      recaptcha_token: recaptchaToken
    })
})

export {
  fetchAssessmentFiles,
  createAssessmentFile,
  deleteAssessmentFile,
  openInvitationAssessmentDialog,
  closeInvitationAssessmentDialog,
  inviteToAssessmentFile
}
